import {Graphics} from './GraphicService';

class ToolbarOptions {
  // TODO: As of 05/08/2025, this is being used as both the icon and to distinguish the type of button from an icon
  // and a text button. We can add a type property and then a config object for specific config per type
  /** @type {string} */
  icon = '';
  /** @type {string} */
  action = '';
  /** @type {string} */
  name = '';
  // BEGIN TODO: Consider how to handle this better, as not every type of ToolbarOption needs these properties */
  /** @type {string | undefined} Vuetify v-btn variant for 'Text' buttons; undefined uses the app default (flat) */
  variant = undefined;
  // END TODO
  /** @type {ColorPickerOptions[] | IconPickerOptions[]} */
  pickers = [];
  /** @type {AlignmentOptions[]} */
  dropdownOptions = [];
  /** @type {() => boolean} */
  isSelected = null;
  /** @type {(option: string)=>string} Gets the color of whatever option passed to the label */
  color = null;
  /** @type {boolean} */
  disabled = false;
  /** @type {boolean} */
  loading = false;
  /** @type {(option: string)=>void} Generic callback function for most toolbar buttons, typically styles label text */
  callback = null;
  /** @type {(option: string, color: string)=>void} Callback for setting the label box's border color */
  boxBorderColorCallback = null;
  /** @type {(option: string, color: string)=>void} Callback for setting the label box's fill color */
  boxFillColorCallback = null;
  /** @type {(option: string, color: string)=>void} Callback for setting the label box's text border color */
  textBorderColorCallback = null;
  /** @type {(option: string, color: string)=>void} Callback for setting the label box's text color */
  textColorCallback = null;
}

class ColorPickerOptions {
  constructor({title, getColor, setColor, allowTransparent = true, availableColors = ['#000000', '#ffffff', '#eeeeee', '#405866', '#e18d3d']}) {
    /** @type {string} */
    this.title = title;
    /** @type {()=>string} */
    this.getColor = getColor;
    /** @type {(color: string)=>void} */
    this.setColor = setColor;
    /** @type {boolean} provides an option to be transparent */
    this.allowTransparent = allowTransparent;
    /** @type {string[]} colors available in colorPicker */
    this.availableColors = availableColors;
  }
}

class IconPickerOptions {
  constructor({title, getIcon, setIcon, allowTransparent = true, icons = [
    ['Black-Multi-Family', 'Gray-Multi-Family', 'Orange-Multi-Family', 'Yellow-Multi-Family'],
    ['Black-Circle', 'Gray-Circle', 'Orange-Circle', 'Yellow-Circle', 'Brown-Circle'],
    ['Black-Acquisition', 'Gray-Acquisition', 'Orange-Acquisition', 'Yellow-Acquisition', 'Brown-Acquisition'],
    ['Black-DataCenterProject', 'Gray-DataCenterProject', 'Orange-DataCenterProject', 'Yellow-DataCenterProject', 'Brown-DataCenterProject'],
    ['Black-Compass-Up', 'Gray-Compass-Up', 'Orange-Compass-Up', 'Yellow-Compass-Up', 'Brown-Compass-Up', 'Green-Compass-Up'],
    ['Blue-Balloon-Flat', 'LightBlue-Balloon-Flat', 'Red-Balloon-Flat', 'Yellow-Balloon-Flat', 'Purple-Balloon-Flat', 'Green-Balloon-Flat', 'Blue-Portfolio-Flat'],
  ]}) {
    /** @type {string} */
    this.title = title;
    /** @type {()=>string} */
    this.getIcon = getIcon;
    /** @type {(icon: string)=>void} */
    this.setIcon = setIcon;
    /** @type {string[][]} icons available in iconPicker */
    this.icons = icons;
  }
}

class AlignmentOptions {
  constructor({name, icon, action, textAlign, callback, isSelected}) {
    /** @type {string} */
    this.name = name;
    /** @type {string} */
    this.icon = icon;
    /** @type {string} */
    this.action = action;
    /** @type {string} */
    this.textAlign = textAlign;
    /** @type {(option: string)=>void} */
    this.callback = callback;
    /** @type {()=>boolean} */
    this.isSelected = isSelected;
  }
}

export {
  Graphics,
  ToolbarOptions,
  ColorPickerOptions,
  IconPickerOptions,
  AlignmentOptions,
};
